<template>
	<div id="rename-custom-lut-folder-modal" class="modal-new hidden">
		<span class="title">Rename LUT Folder</span>
		<input v-model="name" type="text" name="folder-name" placeholder="Enter folder name" />
		<div class="buttons-continer">
			<v-btn :disabled="processing" dark class="modal-btn --primary" @click="renameFolder">Rename</v-btn>
			<button type="button" class="modal-btn --cancel" @click="close">Cancel</button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            name: "",
            processing: false
        }
    },

    computed: {
        ...mapState('UserFilesCustomLuts', ['folder']),
    },

    watch: {
        folder(newValue) {
            this.name = newValue.name
        }
    },

    methods: {
        async renameFolder() {
            if (this.name == "") return;

            this.processing = true;
            await this.$store.dispatch("UserFilesCustomLuts/renameFolder", {
                name: this.name,
                folderId: this.folder.id
            });
            await this.$store.dispatch("UserFilesCustomLuts/index");
            window._Adjustments.customLUT.refreshAllBlocks();
            this.processing = false;

            this.close();
        },
        close() {
            window.UI.hideModal();
            window.UI.showModal(window.UI.modals.customLUT.edit.el);
        },
    },
};
</script>

<style></style>
